import { render, staticRenderFns } from "./ProjectIndex.vue?vue&type=template&id=bfde7232&scoped=true&"
import script from "./ProjectIndex.vue?vue&type=script&lang=js&"
export * from "./ProjectIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProjectIndex.vue?vue&type=style&index=0&id=bfde7232&prod&scoped=true&lang=less&"
import style1 from "./ProjectIndex.vue?vue&type=style&index=1&id=bfde7232&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfde7232",
  null
  
)

export default component.exports